import React from "react";
import { inject } from "mobx-react";
import { Redirect } from "react-router-dom";
import Protected from "./Protected";

export default WrappedComponent => {
  class NotBasicProtected extends React.Component {
    render() {
      const {
        rootStore: { authStore }
      } = this.props;
      if (authStore.isAdmin || authStore.isUmpireAttendant || authStore.isBoxOfficeAdmin) {
        return <WrappedComponent {...this.props} />;
      } else {
        return <Redirect to="/" />;
      }
    }
  }

  return inject("rootStore")(Protected(NotBasicProtected));
};
